import React from 'react'

import RightInventorySelect from './RightInventorySelect'
import RightInventoryTableHeader from './RightInventoryTableHeader'
import ErrorMessage from '../../../../../../../../../../components/Form/ErrorMessage'

import { RIGHT_INVENTORY_SELECT } from '../../../../../fields'

const RightInventoryTable = ({ formik }) => {
  const { values, errors } = formik

  const inventoryError = errors[RIGHT_INVENTORY_SELECT]
  const minLengthInventoryError = typeof inventoryError === 'string' && inventoryError

  return (
    <>
      {!!values[RIGHT_INVENTORY_SELECT]?.length && <RightInventoryTableHeader />}

      <RightInventorySelect formik={formik} />

      {minLengthInventoryError && <ErrorMessage error={minLengthInventoryError} />}
    </>
  )
}

export default RightInventoryTable
